export default __webpack_public_path__ + "static/media/xls.3dde7754.svg";